"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => {
    return {
        schemaType: "object",
        properties: [
            {
                title: "",
                propertyName: "message",
                schema: {
                    schemaType: "message",
                    text: "ここでシステム共通の設定をできるようにする",
                },
            },
        ],
    };
};
